import getCustomDomainComponents from "./getCustomDomainComponents";
import { Environment, settings } from "shared";

const apiDomains = {
  "test-runner": "http://local.lingoapp.com",
  development: "http://local.lingoapp.com:9000",
  test: "https://api-test.lingoapp.com",
  staging: "https://api-staging.lingoapp.com",
  production: "https://api.lingoapp.com",
};

type DomainComponents = {
  protocol: string;
  subdomain: string;
  port: string;
};
const wwwDomains: Record<string, DomainComponents> = {
  "test-runner": {
    protocol: "http",
    subdomain: "local",
    port: "8080",
  },
  development: {
    protocol: "http",
    subdomain: "local",
    port: "8080",
  },
  test: {
    protocol: "https",
    subdomain: "www-test",
    port: "",
  },
  staging: {
    protocol: "https",
    subdomain: "www-staging",
    port: "",
  },
  production: {
    protocol: "https",
    subdomain: "www",
    port: "",
  },
};

export const getWWWDomainComponents = (): DomainComponents => {
  const env = settings.environment;
  const domain = wwwDomains[env];
  if (domain) return domain;
  throw new Error("Environment not found in config.");
};

// By default, spaces with custom domains access the api through
// lingo-api.<custom-domain>.com. This object allows us to override
// that behavior for specific spaces with special DNS needs.
const hostOverrides = {
  "brandportal.mwg.aaa.com": "mwg.aaa.com",
  "brandhub.rmit.edu.au": "brandhub.rmit.edu.au",
};

export const getApiDomain = (): string => {
  const { host, identifier } = getCustomDomainComponents();

  if (host) {
    // Local with custom domain
    if (settings.environment === Environment.development) {
      return `http://local.${host}:9000`;
    }

    return `https://lingo-api.${hostOverrides[identifier] ?? host}`;
  }

  const env = settings.environment;
  const domain = apiDomains[env];
  if (domain) return `${domain}`;
  throw new Error("Environment not found in config.");
};

export const getApiServiceURL = (endpoint?: string): string => {
  let path = endpoint || "";
  if (path[0] === "/") path = path.substring(1);
  return `${getApiDomain()}/v4/${path}`;
};
